import {Component} from 'react'
import {Field} from 'redux-form'

import CheckboxToggle from './CheckboxToggle.jsx'

import normBoolean from '../Normalizer/boolean.js'

export default class CheckboxToggleList extends Component {
  render() {
    const {id, fields, meta, customOnChange, disabled} = this.props

    return (
      <div id={id} className="checkbox-container">
        {meta.error && (
          <div className="error-container text-center m-3">
            <span>{meta.error}</span>
          </div>
        )}
        <ul className="d-flex flex-wrap">
          {fields.map((field, index) => {
            return (
              <li className={`col-md-6 ${index % 2 === 0 ? 'pr-md-5' : 'pl-md-5'}`} key={index}>
                <Field
                  name={`${field}.checked`}
                  label={fields.getAll()[index].name}
                  disabled={fields.getAll()[index].disabled || disabled}
                  separator={index < (fields.length - 1)}
                  normalize={normBoolean}
                  component={CheckboxToggle}
                  customOnChange={customOnChange}
                />
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}
